import styled from "styled-components";
import { getBreakpoints } from "../../../assets/store/cssBreakpoints";
const { xs, sm, md, lg, xl, xxl } = getBreakpoints();

export const StyledContainer = styled.div`
    &&& {
        background-color: ${({ bgColor }) => bgColor ?? "transparent"};
        width: 100%;
        font-family: ${({ defaultFontFamily }) =>
            defaultFontFamily ?? "inherit"};
        min-height: ${(props) => (props.mobile ? "fit-content" : "15em")};
        background-image: ${({ bgImage }) => {
            if (bgImage) return `url(${bgImage})`;
            return "unset";
        }};
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
    }
`;

export const Overlay = styled.div`
    &&& {
        background: linear-gradient(
            270deg,
            rgba(0, 0, 0, 0) 0%,
            rgba(0, 0, 0, 0.9) 100%
        );
        width: 100%;
        box-sizing: border-box;
        height: 100%;
        margin: 0;
        padding: 5% 8%;
    }
`;

export const Title = styled.h1`
    &&& {
        color: white;
        text-align: left;
        font-size: ${(props) => (props.mobile ? "5vw" : "40px")};
        text-transform: uppercase;
        width: ${(props) => (props.mobile ? "100%" : "50%")};
        margin-top: 0px;
        margin-bottom: 10px;
        z-index: 0;
    }
`;

export const BodyText = styled.p`
    &&& {
        color: white;
        text-align: left;
        font-size: ${(props) => (props.mobile ? "3.7vw" : "inherit")};
        width: ${(props) => (props.mobile ? "100%" : "50%")};
        margin: 0;
        z-index: 0;
    }
`;
